module.exports = __webpack_public_path__ + "img/en-3.dde88ce6.png";